import { IntegrationPartner } from "definitions/constants";

import AshbyLogo from "assets/ashby_square.png";
import GoogleCalendarLogo from "assets/google_calendar_square.png";
import GreenhouseLogo from "assets/greenhouse_square.svg";
import LeverLogo from "assets/lever_square.jpg";
import SlackLogo from "assets/slack_square.png";
import ZoomLogo from "assets/zoom_square.png";
import RoamLogo from "assets/roam-icon-square.png";
import { IncomingWebhook } from "./incomingWebhook";

export interface AvailableIntegrationType {
  partner: IntegrationPartner;
  connection_type: "oauth" | "webhook_generated_secret" | "webhook_passed_secret";
  event?: string;
  url?: string;
  description: string;
}

export interface CalendarService {
  id: string;
  provider: string;
  useBuiltInVcService: boolean;
}

export interface Integration {
  id: string;
  companyId: string;
  event: string;
  description: string;
  scope: string;
  externalId: string;
  connectionType: string;
  partner: string;
  webhookId?: string;
  createdAt: Date;
  updatedAt: Date;
  webhooks?: IncomingWebhook[];
  isActive: boolean;
  needsReauth?: boolean;
  messageService?: {
    channelsLastSyncedAt?: Date;
    usersLastSyncedAt?: Date;
    url?: string;
    authUrl: string;
  };
  calendarService?: CalendarService;
}

export const getIntegrationLogoUrl = (partner: string): string => {
  const logoMap: Record<string, string> = {
    ashby: AshbyLogo,
    google_calendar: GoogleCalendarLogo,
    greenhouse: GreenhouseLogo,
    lever: LeverLogo,
    slack: SlackLogo,
    zoom: ZoomLogo,
    roam: RoamLogo,
  };

  return logoMap[partner] || "";
};
